import { PageData } from 'api/Pagination/Types'

import { SearchResultDto } from '../../api/Search/Types/SearchResultDto'
import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'

export class SearchApiClient {
  constructor(private apiClient: ApiClient) {}
  getSearchResults: (query?: PageQuery) => Promise<PageData<SearchResultDto[]>> = (query) => {
    return this.apiClient.get(`/search/search?${preparePageQueryParams(query)}`)
  }
}
